import { render, staticRenderFns } from "./SatisfactionRateInfo.vue?vue&type=template&id=9489ff88&scoped=true&"
import script from "./SatisfactionRateInfo.vue?vue&type=script&lang=js&"
export * from "./SatisfactionRateInfo.vue?vue&type=script&lang=js&"
import style0 from "./SatisfactionRateInfo.vue?vue&type=style&index=0&id=9489ff88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9489ff88",
  null
  
)

export default component.exports